import { SalesReportPage } from './SalesReportPage'
import { withSalesReportPage } from './withSalesReportPage'

const ConnectedSalesReportPage = withSalesReportPage(SalesReportPage)

export { ConnectedSalesReportPage as SalesReportPage }
